import { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Button, DialogTitle, DialogActions, DialogContent, IconButton, Tooltip } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

DeleteIconButton.propTypes = {
  title: PropTypes.node,
  action: PropTypes.func,
  cancelAction: PropTypes.func,
  content: PropTypes.node,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function DeleteIconButton({
  title = "Delete",
  content,
  action,
  cancelAction = () => null,
  tooltip = "Delete",
  disabled = false,
  ...other
}) {
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleCloseConfirm = () => {
    cancelAction();
    setOpenConfirm(false);
  };
  const handleAction = () => {
    action();
    setOpenConfirm(false);
  };

  return (
    <>
      <Tooltip title={tooltip} arrow placement="top">
        <IconButton sx={{ px: 0 }} color={"error"} onClick={() => setOpenConfirm(true)} id="action-button" className="action-button" disableRipple disabled={disabled}>
          <DeleteOutlineIcon />
        </IconButton>
      </Tooltip>

      <Dialog fullWidth maxWidth="xs" open={openConfirm} onClose={handleCloseConfirm} {...other}>
        <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>
        {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}
        <DialogActions>
          <Button variant="contained" color={"error"} onClick={handleAction}>
            Delete
          </Button>
          <Button variant="outlined" color="inherit" onClick={handleCloseConfirm}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
